import React, { Component } from 'react'
import _ from 'lodash';

import {
    WithStyles,
    Theme,
    createStyles,
    withStyles,
    Grid,
    Typography,
} from '@material-ui/core';
import {
    ArrowBackOutlined as BackIcon
} from '@material-ui/icons';

import GoalCard from '../components/GoalCard';

import goalServices from '../services/goalManagementService';

const styles = (theme: Theme) => createStyles({
    mb2x: {
        marginBottom: theme.spacing.unit * 2,
    },
    backIcon: {
        verticalAlign: "sub",
        paddingLeft: "-27px",
        marginLeft: "12px",
    },
    heading: {
        display: "inline-block",
        paddingLeft: "40px",
    },
    backGrid: {
        '&:hover': {
            cursor: "pointer"
        }
    }
})

interface DeletedGoalContainerProps extends WithStyles<typeof styles> {
    history: any,
}
interface DeletedGoalContainerState {
    archiveGoalList: any[];
    goalList: any[],
}

class DeletedGoalContainer extends Component<DeletedGoalContainerProps, DeletedGoalContainerState> {
    constructor(props: DeletedGoalContainerProps) {
        super(props);
        this.state = {
            archiveGoalList: [],
            goalList: []
        };
    }

    componentWillMount() {
        goalServices.deletedGoalList()
            .then((res: any) => this.initGoalLits(res));
    }

    initGoalLits(archiveGoalList : any) {
        let { goalList } = this.state;
    
        if (!_.isEmpty(archiveGoalList)) {
          let tempGoal: any = _.groupBy(archiveGoalList, 'groupId');
          let targetYear: any = [];
          let className: any = [];
          goalList = [];
    
          Object.keys(tempGoal).forEach((goalL: any, i: number) => {
            //If no group is present then it will map to null as a key.
            //Since we are intrested in only zero index change target year 
            if (!['null', 'undefined'].includes(goalL)) {
    
              //Will get all target year and map to it on first object only
              if (tempGoal[goalL] && tempGoal[goalL].length > 0) {
                targetYear = tempGoal[goalL].map((g: any) => {
                  return {targetYear : g.targetYear.toString(),
                    _id : g._id }
                  });
                let latestGoalYear = Math.max.apply(null, targetYear.map(function(item : any) {
                  return item.targetYear;
                })).toString();
                let latestGoalId = _.get(targetYear.find((goal: any) => {
                  return goal.targetYear === latestGoalYear;
                }),'_id');
                tempGoal[goalL][0]['latestGoalId']=latestGoalId;
                tempGoal[goalL][0]["targetYear"] = targetYear;
    
                //Will loop over all class at single time
    
                className = tempGoal[goalL].map((goal: any) => goal["class"] && goal["class"].length > 0 ? goal["class"].map((g: any) => g.name) : []);
                className = className.length > 0 ? className.flat("Infinity") : [];
                //Take unique name
                className = Array.from(new Set(className));
                tempGoal[goalL][0]["className"] = className;
                className = [];
                goalList.push(tempGoal[goalL][0]);
    
              }
            }
            else {
              goalList = [...goalList, ...tempGoal[goalL]];
            }
          })
          this.setState({ archiveGoalList : goalList });
        }
      }

    render() {
        const {
            classes,
            history
        } = this.props;

        const { archiveGoalList } = this.state;
        return (
            <Grid container>
                <Grid item xs={12} className={classes.mb2x}>
                    <Grid container spacing={8} alignItems="center" justify="space-between">
                        <Grid item xs="auto" onClick={() => history.goBack()} className={classes.backGrid}>
                            <BackIcon className={classes.backIcon} />
                            <Typography variant="h6" className={classes.heading}>Deleted Goals</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems="center">

                        {_.map(archiveGoalList, (d: any, i: number) => (
                            <Grid key={`index-${i}`} item xs={12} sm={6} md={4}>
                                <GoalCard
                                    history={this.props.history}
                                    data={d}
                                    years={""}
                                    archived={true}
                                />
                            </Grid>
                        ))}

                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

//@ts-ignore
export default withStyles(styles)(DeletedGoalContainer);